// Helper to format INR currency
export const formatINR = (n) => {
    if (n == null || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(n);
};

// Build a wa.me link with a contextual message
export const waLink = (number, message) => {
    const num = (number || "919971925446").replace(/\D/g, "");
    const text = encodeURIComponent(message || "Hi, I want the best price for Signia Styletto IX.");
    return `https://wa.me/${num}?text=${text}`;
};

export const telLink = (number) => `tel:${(number || "+919888438843").replace(/\s/g, "")}`;
